module.exports = __webpack_public_path__ + "img/222A1605.5810469b.jpg";